"use client";
import { useTranslations } from "next-intl";
import React, { useEffect, useState } from "react";
import Step, { StepStatus } from "./Step";
import { useShoppingCartStore } from "@/lib/store/shoppingCart";
import EmptyState from "../EmptyState";
import CartContent from "./CartContent";
import CartContentBuyBow from "./CartContent-BuyBow";
import { Controller, useForm } from "react-hook-form";
import clsx from "clsx";
import { RingLoader } from "react-spinners";
import { useUserStore } from "@/store/user.store";
import { App } from "antd"; // 添加这行导入
import AccountInfo from "./AccountInfo";
import { contactInfo } from "@/lib/contacts";
import PayMeth from "./Paymeth";
import { OrderSum } from "./OrderSum";
import { Placeholder } from "../Placeholder";
import { BodyText } from "../BodyText";
import { useShoppingCart } from "@/lib/hooks/useShoppingCart";
import axios from "axios";
import {
	CheckoutAddAddress,
	CheckoutAddBillingAddress,
	EmailUpdate,
	GetShippingMethodlist,
	UpdateCheckoutMutation,
	UpdateCheckoutShippingMethod,
} from "@/lib/api/Checkout";
import { defaultLocale, isDev } from "@/lib/utils/util";
import { useRouter } from "@/navigation";
import { getAddresslist } from "@/lib/api/user";
import Collapse from "../Collapse";
import { Link } from "@/navigation";
import Airwallex from "./components/Card";
import { HomeTaile } from "../Contact/ConcatPage";
import Coupon from "./Coupon";
import { getChannelLanguageMap } from "@/lib/api/channel";
import { useUserAuth } from "@/lib/hooks/useUserAuth";
import VisitorAddress from "./VisitorAddress";

function Index() {
	const { findCheckout, BuyBowfindCheckout } = useShoppingCart();
	const { isLogin } = useUserAuth();
	const t = useTranslations();
	const [orderStatusText, setOrderStatusText] = useState<string>(
		t("message.db061d7ad349624a868aa8a585db77fccca3"),
	);
	// 选中的步骤
	const [activeId, setActiveId] = useState(1);
	// 将 message 替换为 App.useApp()
	const { message } = App.useApp();

	const stepsStatus = (id: number) => {
		const status: StepStatus[] = ["complete", "current", "incomplete"];
		if (activeId === 3) return status[0];
		if (id === activeId) return status[1];
		if (id < activeId) return status[0];
	};

	//购物车数据
	const { cartList, isCart, BuyBowcheckoutId, BuyBowCartList } = useShoppingCartStore() as any;
	//填地址
	const [showForm, setShowForm] = useState(false);
	//是否填地址
	const [isAddress, setisAddress] = useState(false);

	const { userInfo } = useUserStore();

	// 地址列表
	const [shipping, setShipping] = useState<any>(null);

	// 选中的地址
	const [activeshipping, setactiveshipping] = useState<any>(null);

	//是否展开
	const [isOpen, setIsOpen] = useState(false);

	//支付方式
	const [PaymentMethod, setPaymentMethod] = useState("paypal");

	// Airwallex 数据
	const [AirwallexDetail, setAirwallexDetail] = useState<any>(null);

	let router = useRouter();
	const {
		register,
		handleSubmit,
		setValue,
		reset,
		formState: { errors, isValid },
		getValues: getFormValues,
		control,
	} = useForm({
		mode: "onBlur",
	});

	const [loading, setLoading] = useState(false);
	const [isDataReady, setIsDataReady] = useState(false);

	useEffect(() => {
		if (cartList || BuyBowCartList) {
			setIsDataReady(true);
		}
	}, [cartList, BuyBowCartList]);

	const onSubmit = async (data: any) => {
		let List = isCart ? { ...cartList } : { ...BuyBowCartList };

		if (!List.lines.length) return message.error(t("message.1a0ec3c72a531b4791288d44a37faf6da887"));

		if (isLogin() && !activeshipping) {
			return message.error(t("message.7b47b897b847014065a39f5b807998984337a3"));
		}
		setLoading(true);
		if (activeshipping) {
			try {
				console.log("提交到服务器的地址数据:", activeshipping);

				// 定义包含所有必要字段的接口
				interface AddressFormData {
					firstName: string;
					lastName: string;
					companyName?: string;
					streetAddress1: string;
					city?: string;
					countryArea?: string;
					postalCode: string;
					country: string;
					phone: string;
				}

				// 创建基础表单数据
				let Formdata: Partial<AddressFormData> = {
					firstName: activeshipping.firstName,
					lastName: activeshipping.lastName,
					companyName: activeshipping.companyName,
					streetAddress1: activeshipping.streetAddress1,
					city: activeshipping.city,
					countryArea: activeshipping.countryArea,
					postalCode: activeshipping.postalCode,
					phone: activeshipping.phone,
				};

				// 处理country字段 - 确保正确提取国家代码
				if (isLogin()) {
					// 登录用户的country处理
					if (activeshipping.country?.code) {
						Formdata.country = activeshipping.country.code;
					} else if (typeof activeshipping.country === "string") {
						Formdata.country = activeshipping.country;
					}
				} else {
					// 游客用户的country处理
					Formdata.country = activeshipping.country;
				}

				// 确保country字段存在且格式正确
				if (!Formdata.country) {
					console.error("国家信息未正确传递!", activeshipping);
					return message.error(t("message.country_required") || "Country is required");
				}

				console.log("处理后的表单数据:", Formdata);

				// 购物车添加地址
				let { checkoutShippingAddressUpdate } = await CheckoutAddAddress({
					checkoutId: List.id,
					...Formdata,
				});
				let { checkoutBillingAddressUpdate } = await CheckoutAddBillingAddress({
					checkoutId: List.id,
					...Formdata,
				});

				setLoading(false);

				if (checkoutShippingAddressUpdate.errors.length > 0) {
					return message.error(
						checkoutShippingAddressUpdate.errors[0].field +
							"-" +
							checkoutShippingAddressUpdate.errors[0].message,
					);
				} else {
					setisAddress(true);
					setShowForm(false);
					// message.success(t("message.c1d1b0fe14107a4782b8836e84bcf8f55e94"));
				}
			} catch (e) {
				message.error(t("message.fb1ec174b6ac8f409ffa6ebdf48e2666cc5e"));
			} finally {
				setLoading(false);
			}
		}

		try {
			//获取仓库ID
			//1.获取配送方式的数据
			let ShippingMethods = await GetShippingMethodlist(List.id);
			// console.log("showForm0", ShippingMethods);
			let ShippingMethodid =
				ShippingMethods.checkout.availableShippingMethods.length > 0
					? ShippingMethods.checkout.availableShippingMethods[0].id
					: null;
			// console.log("showForm1", ShippingMethods, ShippingMethodid);

			//2.gx配送方式
			let ShippingMethoddata =
				ShippingMethodid && (await UpdateCheckoutShippingMethod(List.id, ShippingMethodid));
			// console.log("showForm2", ShippingMethoddata);

			// 更新邮箱
			await EmailUpdate(List.id, !isLogin() ? activeshipping.email : userInfo.email);
			const channel = (await getChannelLanguageMap())[defaultLocale];
			if (isCart) {
				// 1. 刷新购物车数据
				await findCheckout(channel);
			} else {
				await BuyBowfindCheckout(channel);
			}

			// console.log(List, "showForm3", ShippingMethoddata);

			//更新 checkout 配送方式的 mutation
			let UpdateMutation =
				ShippingMethoddata &&
				(await UpdateCheckoutMutation(
					ShippingMethoddata.checkoutShippingMethodUpdate.checkout.shippingMethod.id,
					List.id,
				));

			//支付方式
			if (PaymentMethod == "paypal") {
				//paypal 支付
				// console.log("showForm4", UpdateMutation);
				//获取链接
				const datapaypal = await axios.post(
					`${process.env.NEXT_PUBLIC_LANGUAGE_LIST_URL}/payment/create_paypal_payment`,
					{
						checkout_id: List.id,
					},
				);
				setLoading(false);
				setActiveId(3);
				// console.log("showForm5", datapaypal);
				if (datapaypal.data.code == 200) {
					setTimeout(() => {
						let PalURL = datapaypal.data.detail.approval_url;
						if (PalURL) {
							return window.open(PalURL, isDev ? "_blank" : "_self");
						}
						message.error(datapaypal.data.message);
					}, 500);
				}
			} else {
				//创建airwallex_DATA
				const { data } = await axios.post(
					`${process.env.NEXT_PUBLIC_LANGUAGE_LIST_URL}/payment/create_airwallex_payment`,
					{
						checkout_id: List.id,
					},
				);

				console.log(data, "data received");

				if (data.code == 200) {
					setAirwallexDetail(data.detail);
					setActiveId(2);
				}
			}
		} catch (e) {
			console.log(e.message);
		}
	};
	useEffect(() => {
		getdata();
	}, []);

	//获取数据列表
	async function getdata() {
		if (!isLogin()) {
			return;
		}
		setLoading(true);
		let data = await getAddresslist(userInfo.token);
		if (data.me.addresses && data.me.addresses.length > 0) {
			// 设置地址信息
			setShipping(data.me.addresses);
			let filterdata = data.me.addresses.filter((address) => address.isDefaultShippingAddress)[0] || null;
			// console.log(data.me.addresses, "data.me.addresses", filterdata);
			setactiveshipping(filterdata);
		}
		setLoading(false);
	}

	function changeIsOpen() {
		if (activeshipping) {
			setIsOpen(!isOpen);
		} else {
			router.push("/center");
		}
	}
	//airwallex 回调
	function AirwallexCallback() {
		setActiveId(3);
	}

	const MAX_DURATION = 2 * 60 * 1000; // 2分钟
	const INTERVAL = 4000; // 4秒
	useEffect(() => {
		let intervalId: NodeJS.Timeout;
		let startTime: number;

		async function getQuerId() {
			if (PaymentMethod == "paypal") {
				return;
			}

			try {
				const { data } = await axios.get(
					`${process.env.NEXT_PUBLIC_LANGUAGE_LIST_URL}/payment/get_checkout_status?query_id=${AirwallexDetail.query_id}`,
				);

				// console.log(data, 'airwallex_DATA');

				if (data.code === 200) {
					// 支付成功，跳转并清除定时器
					if (data.detail.payment_status === "success") {
						clearInterval(intervalId);
						data.detail.order_id && router.push(`/paypal-state?checkout_id=${data.detail.order_id}`);
						return;
					}
				}

				// 检查是否超过2分钟
				if (Date.now() - startTime >= MAX_DURATION) {
					clearInterval(intervalId);
					console.log("轮询：已经过了2分钟");
				}
			} catch (error) {
				console.error("查询订单状态出错：", error);
			}
		}

		if (activeId === 3) {
			startTime = Date.now(); // 记录开始时间
			getQuerId(); // 立即执行一次
			intervalId = setInterval(getQuerId, INTERVAL);

			// 清理函数
			return () => {
				clearInterval(intervalId);
			};
		}
	}, [activeId]);

	return (
		<div>
			<HomeTaile msg={t("checkout.Checkout")} />
			<div className="bg-themeSecondary100 pt-6">
				<Step
					steps={[
						{
							id: 1,
							name: t("message.cfe62e95200fa44dc3f8874281d7421873f4"),
							active: activeId === 1,
							status: stepsStatus(1),
							children: (
								<div className="container">
									{!isDataReady ? (
										<div className="flex h-[50vh] items-center justify-center py-20">
											<RingLoader color="#f39700" size={40} />
										</div>
									) : cartList?.lines?.length > 0 || BuyBowCartList?.lines?.length > 0 ? (
										<div className="flex flex-col pb-28 pt-8">
											<div className="mx-auto mb-5 w-full">
												<div className="relative overflow-hidden rounded-xl bg-white p-6 shadow-md">
													<div className=" ">
														<div className="mb-6 flex justify-center rounded bg-white p-2.5 text-2xl font-medium text-themeDark">
															<h3 className="">{t("checkout.86317421d9bc62436858c0333136cb6c40e6")}</h3>
														</div>

														<div className="flex flex-col lg:flex-row lg:gap-6">
															<div className="mb-6 lg:mb-0 lg:w-3/5">
																{isLogin() ? (
																	<>
																		<VisitorAddress setactiveshipping={setactiveshipping} />
																	</>
																) : (
																	<>
																		<VisitorAddress setactiveshipping={setactiveshipping} />
																	</>
																)}
															</div>

															<div className="lg:w-2/5">
																<div className="mb-5 w-full">
																	<div className="overflow-hidden ">
																		{isCart ? (
																			// 购物车数据
																			<CartContent
																				// @ts-ignore
																				layout="col"
																				showButton={false}
																				showOrderSum={false}
																			/>
																		) : (
																			// 立即购买数据
																			<CartContentBuyBow
																				// @ts-ignore
																				layout="col"
																				showButton={false}
																				showOrderSum={false}
																			/>
																		)}
																	</div>
																</div>

																<form onSubmit={handleSubmit(onSubmit)}>
																	<div>
																		<>
																			{/*支付方式*/}
																			<PayMeth
																				onRadioChange={(val) => {
																					setPaymentMethod(val.id);

																					setValue("payment_method", val);
																				}}
																			/>

																			{/*优惠券*/}
																			<Coupon Cartdata={isCart ? cartList : BuyBowCartList} />

																			{isCart ? (
																				// 订单的总价
																				<OrderSum orderSummary={cartList?.totalPrice?.gross.amount || 0} />
																			) : (
																				// 立即购买数据
																				// 订单的总价
																				<OrderSum
																					orderSummary={BuyBowCartList?.totalPrice?.gross.amount || 0}
																				/>
																			)}
																		</>

																		{/* Order Button */}
																		<div className="flex items-end justify-center">
																			<button
																				id="buy-button"
																				type="submit"
																				className={`${
																					activeshipping
																						? loading
																							? "cursor-not-allowed bg-gray-800 text-white shadow-md"
																							: "shadow-4xl cursor-pointer bg-main text-white hover:opacity-70"
																						: "cursor-not-allowed bg-main text-white opacity-50"
																				} font-Roboto mt-6 flex items-center justify-center gap-4 rounded-full px-[120px] py-4 text-base font-semibold capitalize transition-all duration-300 ease-in-out max-md:px-[40px]`}
																				disabled={!activeshipping || loading}
																			>
																				{loading
																					? t("order.Processing") + "..."
																					: showForm
																						? t("form.89d6993324b64541c93976dbb5de7af086c0")
																						: t("message.cfe62e95200fa44dc3f8874281d7421873f4")}
																				{loading && <RingLoader color="#fff" size={20} />}
																			</button>
																		</div>

																		<AccountInfo cOrderId={""} email={contactInfo.email || ""} />
																	</div>
																</form>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									) : (
										<EmptyState />
									)}
								</div>
							),
						},
						{
							id: 2,
							name: t("checkout.f280da5593e54d4dcccbe7a9af91f97d29399"),
							active: activeId === 2,
							status: stepsStatus(2),
							children: (
								<div className="c-flex container flex-col pb-28 pt-8">
									{/* @ts-ignore */}
									<Airwallex AirwallexDetail={AirwallexDetail} AirwallexCallback={AirwallexCallback} />
								</div>
							),
						},
						{
							id: 3,
							name: t("checkout.f280da5593e54d4dcccbe7a9af91f97d2939"),
							active: activeId === 3,
							status: stepsStatus(3),
							children: (
								<div className="c-flex container flex-col pb-28 pt-8">
									<Placeholder
										src="/image/checkout/online_payment.png"
										imageWidth={500}
										imageHeight={400}
										alt="Online payment"
										className="!bg-transparent"
									/>
									<BodyText className="mr-2" size="lg">
										{orderStatusText}
									</BodyText>
									<AccountInfo cOrderId={""} email={contactInfo.email || ""} />
								</div>
							),
						},
					]}
				/>
			</div>
		</div>
	);
}

export default React.memo(Index);
